<div class="container mt-5">

    <foehn-page-counter></foehn-page-counter>

    <foehn-form>
        <h3> Documents à joindre</h3>
        <div class="row align-baseline">
            <div *ngIf="form.requestOrigin.libelleConfigurable" [innerHTML]="getRenderHTML(true)" class="col-md-8"
                 style="margin-bottom: 30px;">
            </div>
            <foehn-checkbox
                [(model)]="docSelected"
                [elementValue]="wholeValue"
                [elements]="documentTypes"
                [label]="'attachments.type.label' | fromDictionary"
                [required]="true"
                elementLabel="valeur"
                name="docSelected"
                style="margin-left: 25px"
            ></foehn-checkbox>
        </div>
        <div class="row">
            <div class="col-md-8">
                <ng-container *ngFor="let typeDoc of documentTypes | keyvalue ; index as index">

                    <foehn-multi-upload
                        (change)="onDocumentsAdded()"
                        *ngIf="isBoxChecked(typeDoc.value.id)"
                        [(model)]="listeDocumentsPossibles[index].documentReference"
                        [customErrors]="{'413': 'Votre pièce jointe {fileName} a une taille supérieur au maximum autorisé ({fileMaxSize} <abbr title=\'Megaoctet\'>Mo</abbr>)'}"
                        [dragAndDrop]="false"
                        [helpText]="'attachments.personalDocuments.help' | fromDictionary"
                        [label]="'Documents de type «' + typeDoc.value.valeur + '»'"
                        [multiple]="true"
                        [name]="'listeDocuments[' + index + '].documentReference'"
                        [reference]="reference"
                        [required]="false"
                        style="margin-left: 10px; vertical-align: baseline;"
                    ></foehn-multi-upload>

                </ng-container>

            </div>
        </div>
        <h3> Accord sur le traitement des données</h3>
        <div class="row">
            <div *ngIf="form.requestOrigin.libelleConfigurable" [innerHTML]="getRenderHTML(false)" class="col-md-8"
                 style="margin-bottom: 30px;">
            </div>
            <div class="col-md-8">
                <foehn-boolean-radio
                    [(model)]="form.requestSummary.approveGeneralConditions"
                    [label]="'request-procuration.approveGeneralConditions.label' | fromDictionary"
                    name="requestSummary.approveGeneralConditions"
                    required="true"
                >
                </foehn-boolean-radio>

                <foehn-navigation
                    (onNext)="send()"
                    (onPrevious)="previous()"
                    id="navigation"
                ></foehn-navigation>
            </div>
        </div>
    </foehn-form>
</div>
